import React from "react";
import { getI18n } from "react-i18next";

import "./style.css";

const CroppedImageModal = ({ fileChangedHandler, file, children }) => {
  const _ = getI18n();

  const saveCrop = async () => {
    fileChangedHandler(file);
    window.$("#croppedImageModal").modal("hide");
  };

  return (
    <div
      className="modal fade bd-example-modal-lg"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
      id="croppedImageModal"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLongTitle">
              {_.t("ADD_SLIDE")}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="container-fluid">{children}</div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              {_.t("Close")}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => saveCrop()}
            >
              {_.t("SUBMIT")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CroppedImageModal;
